import { render, staticRenderFns } from "./homeCarousel.vue?vue&type=template&id=f2defeac"
import script from "./homeCarousel.vue?vue&type=script&lang=js"
export * from "./homeCarousel.vue?vue&type=script&lang=js"
import style0 from "./homeCarousel.vue?vue&type=style&index=0&id=f2defeac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports